import React from "react";
import styled from "@emotion/styled";

import { useTheme } from "../../contexts/themeContext";
import Modal from "./Modal";

function AboutUs() {
  const theme = useTheme();
  const [show, setShow] = React.useState(false);

  return (
    <AboutUsLayout hcolor={theme.secondDark} pcolor={theme.mainDark}>
      <div>
        <h2>Despre Noi</h2>
        <p>
          <b>DAMECA LV</b> livrează en-gross următoarele produse: orez, hrișcă,
          făină. Marfa este livrată atât cu autocamioanele cât și pe calea
          ferată, până la depozitul clientului. Compania noastră propune doar
          produse certificate. Toate produsele corespund standardelor
          internaționale și celor din Republica Moldova.
        </p>
        <ContactUsButton
          background={theme.secondDark}
          textColor={theme.mainDark}
          onClick={() => setShow(true)}
        >
          Contacteaza-ne
        </ContactUsButton>
        {show && (
          <Modal
            close={e => {
              setShow(false);
            }}
          />
        )}
      </div>
      <img
        alt="logistics"
        src="https://cdn-images-1.medium.com/max/1200/0*nJn-QN8s87A1mXg_"
      />
    </AboutUsLayout>
  );
}

const AboutUsLayout = styled.section`
  display: flex;
  justify-content: space-between;
  padding: 10px;

  margin-bottom: 50px;

  @media (max-width: 500px) {
    flex-direction: column-reverse;
  }

  img {
    width: 55%;
    border-radius: 10px;

    @media (max-width: 500px) {
      width: 100%;
      margin-bottom: 50px;
    }
  }

  div {
    width: 40%;

    @media (max-width: 500px) {
      width: 100%;
    }

    h2 {
      font-size: 25px;
      padding-bottom: 6px;
      border-bottom: 3px solid red;
      display: inline-block;
      margin-bottom: 10px;
      color: ${props => props.hcolor};
      border-color: ${props => props.hcolor};
      font-weight: 600;
    }

    p {
      color: ${props => props.pcolor};
      font-family: "Helvetica Neue", sans-serif;
      font-size: 15px;
      line-height: 24px;
      margin: 0 0 24px;
      text-align: justify;
      text-justify: inter-word;
    }
  }
`;

export const ContactUsButton = styled.button`
  padding: 10px 15px;
  border: 3px solid ${props => props.background};
  font-size: 15px;
  font-family: "Helvetica Neue", sans-serif;
  border-radius: 10px;
  color: ${props => props.textColor};
  cursor: pointer;
  outline: none;

  &:hover {
    transform: scale(1.2);
    transition: all 0.5s;
    color: #fff;
    background: ${props => props.background};
  }
`;

export default AboutUs;
